import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-events-item',
  templateUrl: './operation-events-item.component.html',
  styleUrls: ['./operation-events-item.component.scss']
})
export class OperationEventsItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
